import React, { ReactChild, ReactNode } from "react"
import { Drawer } from "antd"
import "./mythModal.less"
import { toChildArray } from "../../utils/contractUtils"
import {CloseCircleIcon} from "../icons/closeCircleIcon";

interface IProps {
    visible: boolean
    title?: string | ReactNode
    onCancel?: () => void
    loading?: boolean
    children: ReactChild
    className?: string
    footer?: React.ReactNode
    viewMode?: 'fullScreen' | 'topGap'
}

export const MythModalMobile = ({ children, visible, footer, onCancel, loading, title, className, viewMode }: IProps) => {

    const _onCancel = () => {
        if(!loading && onCancel) { //if loading === true, user can't close modal
            onCancel()
        }
    }

    const childrens = toChildArray(children)

    let cssClass = className ? `myth-modal-mobile ${className}` : 'myth-modal-mobile'

    if(viewMode === undefined) {
        viewMode = 'fullScreen'
    }
    else if(viewMode === 'topGap') {
        cssClass = `${cssClass} top-gap`
    }

    const height = viewMode === 'fullScreen' ? '100%' : '90%'

    return <Drawer
        className={cssClass}
        height={height}
        title={title?<>{title}</>:null}
        closeIcon={<CloseCircleIcon />}
        placement="bottom"
        closable={true}
        onClose={_onCancel}
        visible={visible}
        footer={footer}
        >
    {childrens.map(c => c)}
    </Drawer>
}
